import React from 'react'
import {Query} from 'react-apollo'
import {
    ComposedChart,
    ResponsiveContainer,
    Bar,
    XAxis,
    YAxis,
    CartesianGrid,
    Tooltip,
    Legend
} from 'recharts';
import PropTypes from 'prop-types'
import stringToColour from 'string-to-color'
import _ from 'lodash'
import moment from 'moment'

import Loading from '../../components/Loading'

import query from '../../../queries/reports/project_daily_summary'

const formatTimesheetDataForChart = (timesheets) => {
    const tsObj = _.groupBy(timesheets, ({timesheet_date}) => moment(timesheet_date).format('DD/MM/YYYY'))
    return Object.keys(tsObj)
        .map(date => {
            return Object.assign(
                {date},
                tsObj[date].reduce((carry, timesheet) => {
                    carry[timesheet.project_id] = carry[timesheet.project_id] || 0
                    carry[timesheet.project_id] += timesheet.hours_worked
                    return carry
                }, {})
            )
        })

}

const getStackKeysForChart = (timesheets) => {
    return _.uniq(_.map(timesheets, ({project_id}) => project_id))
}

const AxisLabel = ({ axisType, x, y, width, height, stroke, children }) => {
    const isVert = axisType === 'yAxis';
    const cx = isVert ? x : x + (width / 2);
    const cy = isVert ? (height / 2) + y : y + height + 10;
    const rot = isVert ? `270 ${cx} ${cy}` : 0;
    return (
      <text x={cx} y={cy} transform={`rotate(${rot})`} textAnchor="middle" stroke={stroke}>
        {children}
      </text>
    );
  };

const ProjectLast30DaysChart = (props) => {
    //<Line type='monotone' dataKey='uv' stroke='#ff7300'/>
    return (
        <Query query={query} fetchPolicy="network-only">
            {({data: {projectHoursWorkedLast30Days}, loading}) => {

                if(loading) return <Loading/>

                const data = formatTimesheetDataForChart(projectHoursWorkedLast30Days)
                const keys = getStackKeysForChart(projectHoursWorkedLast30Days)

                return (
                    <div style={{ width: '100%', height: '100%', position: 'relative' }}>
                        <div
                            style={{
                                width: '100%',
                                height: '100%',
                                position: 'absolute',
                                top: 0,
                                left: 0
                            }}
                        >
                            <ResponsiveContainer>
                                <ComposedChart data={data}
                                            margin={{top: 20, right: 20, bottom: 20, left: 20}}>
                                    <CartesianGrid stroke='#f5f5f5'/>
                                    <XAxis dataKey="date"/>
                                    <YAxis/>
                                    <Tooltip/>
                                    <Legend/>
                                    {keys.map(key => <Bar key={key} dataKey={key} stackId="a" fill={stringToColour(key)}/>)}

                                </ComposedChart>
                            </ResponsiveContainer>
                        </div>
                    </div>
                )

            }}
            
        </Query>
        
    );
}


export default ProjectLast30DaysChart